import { baseQuery, GET_REFUNDS_ANALYTICS, DELETE_REFUNDS_LEAD } from "@/graphql";
import { createApi } from "@reduxjs/toolkit/query/react";

interface RefundsAnalyticsInput {
  pageNo?: number;
  pageSize?: number;
  searchKeyword?: string;
  dateFrom?: string;
  dateTo?: string;
}

interface RefundsAnalyticsResponse {
  refundsAnalytics: {
    data: {
      summary: {
        totalLeads: number;
        verifiedLeads: number;
        leadsWithAnalysis: number;
        totalUploadCount: number;
        totalRefundIdentified: number;
        averageRefundPerLead: number;
        leadsWithLiquidationData: number;
      };
      leads: Array<{
        email: string;
        firstName: string;
        lastName: string;
        company: string;
        verified: boolean;
        verifiedAt: string | null;
        funnelStep: string;
        uploadCount: number;
        latestTotalRefund: number | null;
        latestEntryCount: number | null;
        latestHasLiquidationData: boolean | null;
        source: string | null;
        utmSource: string | null;
        utmMedium: string | null;
        utmCampaign: string | null;
        referrer: string | null;
        createdAt: string;
        updatedAt: string;
      }>;
      leadsMeta: {
        total: number;
        pageNo: number;
        pageSize: number;
      };
      eventCounts: Array<{ event: string; count: number }>;
      funnel: Array<{ step: string; count: number }>;
      topCompanies: Array<{
        company: string;
        leadCount: number;
        totalRefund: number;
      }>;
    } | null;
    error: string | null;
  };
}

export const refundsAnalyticsApi = createApi({
  reducerPath: "api/refundsAnalytics",
  tagTypes: ["refundsAnalytics"],
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getRefundsAnalytics: builder.query<
      RefundsAnalyticsResponse,
      RefundsAnalyticsInput
    >({
      query: (variables) => ({
        document: GET_REFUNDS_ANALYTICS,
        variables: { input: variables },
      }),
      providesTags: ["refundsAnalytics"],
    }),
    deleteRefundsLead: builder.mutation<
      { deleteRefundsLead: { success: boolean; error: string | null } },
      { email: string }
    >({
      query: (variables) => ({
        document: DELETE_REFUNDS_LEAD,
        variables,
      }),
      invalidatesTags: ["refundsAnalytics"],
    }),
  }),
});

export const { useGetRefundsAnalyticsQuery, useDeleteRefundsLeadMutation } =
  refundsAnalyticsApi;
